import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { get } from "lodash";
import Slices from "../slices";

export default function Home() {
  const dispatch = useDispatch();
  const [extraClass, setExtraClass] = useState(false);
  const pageLoading = useSelector((state) =>
    get(state, "prismic.home_page.loading", true),
  );
  const page = useSelector((state) =>
    get(state, "prismic.home_page.data", false),
  );

  const slices = get(page, "body");

  useEffect(() => {
    dispatch({
      type: "PRISMIC_LOAD_SINGLE_PAGE",
      key: "home_page",
    });
  }, [dispatch]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    setExtraClass(false);
    setTimeout(() => {
      setExtraClass("yas");
    }, 200);
  }, [pageLoading]);

  return (
    !pageLoading &&
    page && (
      <div className={`animation ${extraClass && extraClass}`}>
        <Slices slices={slices}></Slices>
      </div>
    )
  );
}
